import { FC, useEffect } from 'react';
import {
  setHeaderStage,
  setTableViewScheduleStage,
  setViewScheduleStage,
} from 'entities/index';
import { useExamsSchedule } from 'features/useExamsSchedule';
import { useSchedule } from 'features/useSchedule';
import { useHistoryOfViewStage } from 'shared/hooks';
import { useAppDispatch, useAppSelector } from 'shared/lib';
import {
  StageCalendarSchedule,
  StageExamsTableSchedule,
  StageSchedule,
  StageTableSchedule,
  StageTimelineSchedule,
} from 'widgets/index';

import styles from './styles.module.scss';

export const PageSchedule: FC = () => {
  const { headerSwitchStage, scheduleViewStage } = useAppSelector(
    (state) => state.viewStageReducer,
  );
  const {
    getViewScheduleHistory,
    getViewStageHistory,
    getTableViewScheduleStageHistory,
  } = useHistoryOfViewStage();
  const { scheduleQuery, token, requestText } = useSchedule();
  const { examsScheduleQuery } = useExamsSchedule();

  const dispatch = useAppDispatch();

  useEffect(() => {
    const viewStage = getViewStageHistory();
    const viewSchedule = getViewScheduleHistory();
    const tableViewScheduleStageHistory = getTableViewScheduleStageHistory();
    if (viewStage) dispatch(setHeaderStage(viewStage));
    if (viewSchedule) dispatch(setViewScheduleStage(viewSchedule));
    if (tableViewScheduleStageHistory)
      dispatch(setTableViewScheduleStage(tableViewScheduleStageHistory));
  }, []);

  useEffect(() => {
    if (headerSwitchStage === 'schedule') {
      scheduleQuery();
    } else if (headerSwitchStage === 'exams') {
      examsScheduleQuery();
    }
  }, [token, requestText, headerSwitchStage]);

  const getContainer = () => {
    if (headerSwitchStage === 'schedule') {
      if (scheduleViewStage === 'column') {
        return <StageSchedule />;
      } else if (scheduleViewStage === 'timeline') {
        return <StageTimelineSchedule />;
      } else if (scheduleViewStage === 'table') {
        return <StageTableSchedule />;
      } else if (scheduleViewStage === 'calendar') {
        return <StageCalendarSchedule />;
      }
    } else if (headerSwitchStage === 'exams') {
      return <StageExamsTableSchedule />;
    }
  };
  return (
    <div className={styles['page']}>
      <div className={'page__container'}>{getContainer()}</div>
    </div>
  );
};
